/*eslint-disable no-script-url*/

import React from 'react';
import edit from "../../../assets/images/ic_edit.png";
import copyIcon from "../../../assets/images/ic_copy.png";
import cancel from "../../../assets/images/ic_cancel_black.png";
import IcCancel from "../../../assets/images/ic_cancel.png";
import Loader from "../../../common/Loader";

const EnResult = props => {
    const fetchResults = () => {
        if (props.results.length > 0){
            return props.results.map((obj, index) =>
                <li key={index}><div className={'wrap'}> {obj} <a className={'copy-icon'} href="javascript:void(0)">
                    <img onClick={() => props.handleTextCopyNotification(obj)} alt="" src={copyIcon}/></a></div>
                </li>
            )
        }
    };

    return (
        <div className={'col-sm-6'}>
            <div className={'heading-txt add'}>
                <h3 className={'f black pull-left'}>Was the word you are looking for:</h3>
                <button type={'button'} className=" bt bt-lg pull-right" >
                    <img alt="" src={edit}/>
                    <p onClick={() => props.handleSuggestedEditPopupShow(true)} className={'f black'}>Suggested Edits</p>
                </button>
            </div>
            <div className={'box-frame'}>
                <ul className={'list'}>
                    {fetchResults()}
                </ul>
                <div className={'suggestion-box'} style={{display: props.editSuggestionPopup.show ? 'block' : 'none'}}>
                    <a onClick={() => props.handleSuggestedEditPopupShow(false)} className={'cancel desktop'} href="javascript:void(0)"><img alt="" src={cancel}/></a>
                    <a className={'cancel mobile'} href="javascript:void(0)"><img alt="" src={IcCancel}/></a>
                    <h3 className={'f black'}>send us suggested edits</h3>
                    <div className={'box'}>
                        <textarea value={props.editSuggestionPopup.text} onChange={props.handleSuggestedEditPopupText}/>
                    </div>
                    <button onClick={props.handleSendSuggestedEdit} className={'bt blue pull-right'} type={'button'}><p className={'f white'}>Send</p></button>
                </div>
                <div className={'no-result'} style={{display: !props.noResults ? 'none' : 'block'}}>
                    <h3 className={'f black'}>No results found <a className={'f black'} href="javascript:void(0)">How to search</a></h3>
                </div>
                <div className={'frame-footer'}>
                    <a href="javascript:void(0)">Suggested Edits</a>
                </div>
                <Loader/>
            </div>
        </div>
    );
};

export default EnResult;


// WEBPACK FOOTER //
// ./src/components/home/partials/EnResult.js